/**
 * Luxury Effects - Paws & Places
 * Scroll reveal, parallax, and interactive effects
 */

(function() {
  'use strict';

  // ============================================
  // SCROLL REVEAL
  // ============================================
  const revealElements = document.querySelectorAll('.reveal, .reveal-left, .reveal-right, .reveal-scale');
  
  const revealObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('revealed');
        revealObserver.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.1,
    rootMargin: '0px 0px -50px 0px'
  });

  revealElements.forEach(el => revealObserver.observe(el));

  // ============================================
  // PARALLAX EFFECT (Desktop Only)
  // ============================================
  if (window.matchMedia('(min-width: 990px) and (hover: hover)').matches) {
    const parallaxElements = document.querySelectorAll('.hero-parallax');
    
    let ticking = false;
    window.addEventListener('scroll', () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          parallaxElements.forEach(el => {
            const scrolled = window.pageYOffset;
            const rate = scrolled * 0.3;
            el.style.transform = `translate3d(0, ${rate}px, 0)`;
          });
          ticking = false;
        });
        ticking = true;
      }
    });
  }

  // ============================================
  // 3D TILT EFFECT (Desktop Only)
  // ============================================
  if (window.matchMedia('(min-width: 990px) and (hover: hover)').matches) {
    const tiltCards = document.querySelectorAll('.tilt-card');
    
    tiltCards.forEach(card => {
      card.addEventListener('mousemove', (e) => {
        const rect = card.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
        const centerX = rect.width / 2;
        const centerY = rect.height / 2;
        const rotateX = (y - centerY) / 20;
        const rotateY = (centerX - x) / 20;
        
        card.style.transform = `perspective(1000px) rotateX(${rotateX}deg) rotateY(${rotateY}deg) scale3d(1.02, 1.02, 1.02)`;
      });
      
      card.addEventListener('mouseleave', () => {
        card.style.transform = 'perspective(1000px) rotateX(0) rotateY(0) scale3d(1, 1, 1)';
      });
    });
  }

  // ============================================
  // SMOOTH SCROLL FOR ANCHOR LINKS
  // ============================================
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function(e) {
      e.preventDefault();
      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    });
  });

  // ============================================
  // IMAGE LAZY LOADING WITH FADE IN
  // ============================================
  const lazyImages = document.querySelectorAll('img[data-src]');
  
  const imageObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const img = entry.target;
        img.src = img.dataset.src;
        img.classList.add('loaded');
        imageObserver.unobserve(img);
      }
    });
  }, {
    rootMargin: '100px'
  });

  lazyImages.forEach(img => imageObserver.observe(img));

  // ============================================
  // HEADER SCROLL EFFECT
  // ============================================
  const header = document.querySelector('header');
  let lastScroll = 0;
  
  window.addEventListener('scroll', () => {
    const currentScroll = window.pageYOffset;
    
    if (currentScroll > 100) {
      header.classList.add('scrolled');
    } else {
      header.classList.remove('scrolled');
    }
    
    if (currentScroll > lastScroll && currentScroll > 200) {
      header.classList.add('header-hidden');
    } else {
      header.classList.remove('header-hidden');
    }
    
    lastScroll = currentScroll;
  });

  // ============================================
  // COUNTER ANIMATION (for trust badges)
  // ============================================
  const counters = document.querySelectorAll('.counter');
  
  const counterObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const counter = entry.target;
        const target = parseInt(counter.dataset.target);
        const duration = 2000;
        const step = target / (duration / 16);
        let current = 0;
        
        const updateCounter = () => {
          current += step;
          if (current < target) {
            counter.textContent = Math.floor(current);
            requestAnimationFrame(updateCounter);
          } else {
            counter.textContent = target;
          }
        };
        
        updateCounter();
        counterObserver.unobserve(counter);
      }
    });
  }, { threshold: 0.5 });

  counters.forEach(counter => counterObserver.observe(counter));

  // ============================================
  // MAGNETIC BUTTON EFFECT (Desktop)
  // ============================================
  if (window.matchMedia('(min-width: 990px) and (hover: hover)').matches) {
    const magneticButtons = document.querySelectorAll('.magnetic-button');
    
    magneticButtons.forEach(button => {
      button.addEventListener('mousemove', (e) => {
        const rect = button.getBoundingClientRect();
        const x = e.clientX - rect.left - rect.width / 2;
        const y = e.clientY - rect.top - rect.height / 2;
        
        button.style.transform = `translate(${x * 0.3}px, ${y * 0.3}px)`;
      });
      
      button.addEventListener('mouseleave', () => {
        button.style.transform = 'translate(0, 0)';
      });
    });
  }

  // ============================================
  // BENTO COLLECTION TITLES (Below Cards)
  // ============================================
  function injectBentoTitles() {
    const collectionCards = document.querySelectorAll('.collection-card');
    
    collectionCards.forEach(card => {
      // Skip if already has title
      if (card.querySelector('.collection-card__title--below')) return;
      
      // Get collection title from various sources
      const titleEl = card.querySelector('.collection-card__title');
      const linkEl = card.querySelector('.collection-card__link');
      const hiddenTitleEl = card.querySelector('.visually-hidden');
      let title = '';
      
      if (titleEl) {
        title = titleEl.textContent.trim();
      } else if (hiddenTitleEl) {
        title = hiddenTitleEl.textContent.trim();
      } else if (linkEl) {
        title = linkEl.textContent.trim();
      }
      
      if (title) {
        const titleDiv = document.createElement('div');
        titleDiv.className = 'collection-card__title--below';
        titleDiv.textContent = title;
        card.appendChild(titleDiv);
      }
    });
  }

  // Run on load and after dynamic content updates
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectBentoTitles);
  } else {
    injectBentoTitles();
  }
  
  // Re-run after Shopify section rendering
  document.addEventListener('shopify:section:load', injectBentoTitles);

})();
